/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Table, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { adminApi } from '../../api';
import { useAlerts } from '../context';
import Loader from '../common/Loader';

function WalletTable({ title, wallets, displayWalletType = false }) {
  const { t } = useTranslation();

  return (
    <>
      <h5 className="mt-4">{title}</h5>
      {wallets.length === 0 ? (
        <div className="text-muted">{t('common:labels.none')}</div>
      ) : (
        <Table bordered className="custom-detail shadow-sm" responsive>
          <thead>
            <tr>
              <th>{t('common:labels.walletNickname')}</th>
              <th>{t('common:labels.userHandle')}</th>
              <th>{t('common:transactions.labels.wallets.type.walletId')}</th>
              {displayWalletType && <th>{t('common:transactions.labels.type')}</th>}
            </tr>
          </thead>
          <tbody>
            {wallets.map((item) => {
              return (
                <tr key={item.wallet_id} className="loaded">
                  <td>{item.name}</td>
                  <td>
                    <Button
                      href={`/admin/end_user/${item.user_handle}/profile`}
                      variant="link"
                      className="p-0 ps-2 text-reset text-underline"
                    >
                      {item.user_handle}
                    </Button>
                  </td>
                  <td>{item.wallet_id}</td>
                  {displayWalletType && <td>{item.type}</td>}
                </tr>
              );
            })}
          </tbody>
        </Table>
      )}
    </>
  );
}

function CompanyWalletsTable() {
  const { t } = useTranslation();
  const { id } = useParams();
  const { setAlert } = useAlerts();
  const [customerReserveWallet, setCustomerReserveWallet] = useState(null);
  const [appOperationalWallets, setAppOperationalWallets] = useState([]);
  const [operationalEntityWallets, setOperationalEntityWallets] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCompanyWallet = async () => {
    try {
      const response = await adminApi.fetchCompanyWallet(id);
      if (response.customer_reserve_wallet) {
        const wallet = Array.isArray(response.customer_reserve_wallet)
          ? response.customer_reserve_wallet[0]
          : response.customer_reserve_wallet;
        setCustomerReserveWallet(wallet);
      }
      setAppOperationalWallets(response.app_operational_wallets || []);
      setOperationalEntityWallets(response.operational_entity_wallets || []);
    } catch (error) {
      setAlert({ message: error, variant: 'warning' });
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchCompanyWallet();
  }, [id]);

  if (loading) return <Loader />;

  if (
    !customerReserveWallet &&
    appOperationalWallets.length === 0 &&
    operationalEntityWallets.length === 0
  ) {
    return <div>{t('admin.applications.operationalWallets.noOperationalWallets')}</div>;
  }

  return (
    <>
      <WalletTable
        title={t('admin.applications.operationalWallets.appOperationalWalletsTitle')}
        wallets={appOperationalWallets}
        displayWalletType
      />
      <WalletTable
        title={t('admin.applications.operationalWallets.crw')}
        wallets={customerReserveWallet ? [customerReserveWallet] : []}
      />
      <WalletTable
        title={t('admin.applications.operationalWallets.operationalEntityWalletsTitle')}
        wallets={operationalEntityWallets}
      />
    </>
  );
}

export default CompanyWalletsTable;
